import * as newsService from '../../../utils/services/news.js';

export default {
    /**
     * @desc 获取新闻内容
     * @param {Object} 
     * @param {String} newsId
     */
    fetchNewsDetail({commit}, newsId){
        return new Promise((resolve, reject)=>{
            newsService
                .fetchNewsDetail({newsId:newsId})
                    .then(news=>{
                        resolve(news)
                    }, err=>{
                        reject(err)
                    })
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/news/actions.js